import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as ROUTES from '../../../../router/Routes';
import { ModalComponent } from '../../../../widgets';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { ACTIVO_BOLETINES } from '../BoletinesReducer';
import BoletinComponent from './Boletin';
import CardEstudianteComponent from './CardEstudiante';
import NotasDefGraficoBarComponent from './NotasDefGraficoBar';

const ListadoBoletines = () => {
  const dispatch = Redux.useDispatch();
  let history = useHistory();

  const boletinesStore = Redux.useSelector((state) => state.boletines);

  const [openBoletinModal, setOpenBoletinModal] = React.useState();

  React.useEffect(() => {
    setOpenBoletinModal(false);
    if (boletinesStore.activo) {
      setOpenBoletinModal(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container spacing={1}>
      {boletinesStore.all.map((el, i) => (
        <Grid item md={3} key={`card_${i}`}>
          <CardEstudianteComponent
            data={el}
            index={i + 1}
            onBoletin={() => {
              dispatch({ type: ACTIVO_BOLETINES, payload: el });
              setOpenBoletinModal(true);
            }}
            activo={boletinesStore.activo && boletinesStore.activo.id === el.id}
            onClose={() => {
              dispatch({ type: ACTIVO_BOLETINES, payload: null });
            }}
          />
        </Grid>
      ))}

      {boletinesStore.activo && (
        <ModalComponent
          id="detalleBoletinModal"
          title={`Boletin del estudiante: ${
            boletinesStore.activo.usuario.perfil.papellido
          } ${boletinesStore.activo.usuario.perfil.sapellido ?? ''} ${
            boletinesStore.activo.usuario.perfil.pnombre
          } ${boletinesStore.activo.usuario.perfil.snombre ?? ''}`}
          open={openBoletinModal}
          maxWidth="100%"
          onClose={() => {
            setOpenBoletinModal(!openBoletinModal);
            dispatch({
              type: ACTIVO_BOLETINES,
              payload: null,
            });
          }}
        >
          <Grid container spacing={1}>
            <Grid item md={12}>
              <BotonComponent
                text="EXPORTAR PDF"
                click={() => {
                  history.push(ROUTES.boletinesPdf.to);
                }}
                red
                downloadIcon
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <CardEstudianteComponent
                data={boletinesStore.activo}
                onBoletin={() => {
                  dispatch({
                    type: ACTIVO_BOLETINES,
                    payload: boletinesStore.activo,
                  });
                  setOpenBoletinModal(true);
                }}
              />

              {boletinesStore.boletin && <NotasDefGraficoBarComponent />}
            </Grid>
            <Grid item xs={12} md={8}>
              <BoletinComponent data={boletinesStore.activo} />
            </Grid>
          </Grid>
        </ModalComponent>
      )}
    </Grid>
  );
};

export default ListadoBoletines;
